import { render, staticRenderFns } from "./DomainCreation.vue?vue&type=template&id=447f4e03&"
import script from "./DomainCreation.vue?vue&type=script&lang=js&"
export * from "./DomainCreation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports